import { useSyncExternalStore } from 'react';

// types
import { MenuProps, NavItemType } from 'types/menu';

const initialState: MenuProps = {
  isDashboardDrawerOpened: false,
  isComponentDrawerOpened: true
};

let menuState = initialState;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function emit() {
  listeners.forEach((listener) => listener());
}

// ==============================|| API - MENU ||============================== //

export function useGetMenu() {
  return {
    menu: undefined as NavItemType | undefined,
    menuLoading: false,
    menuError: undefined,
    menuValidating: false,
    menuEmpty: true
  };
}

export function useGetMenuMaster() {
  const menuMaster = useSyncExternalStore(
    subscribe,
    () => menuState,
    () => menuState
  );

  return {
    menuMaster,
    menuMasterLoading: false
  };
}

export function handlerComponentDrawer(isComponentDrawerOpened: boolean) {
  menuState = { ...menuState, isComponentDrawerOpened };
  emit();
}

export function handlerDrawerOpen(isDashboardDrawerOpened: boolean) {
  menuState = { ...menuState, isDashboardDrawerOpened };
  emit();
}
